import { StyledListItem } from '@/components/AssetsPage/PopoverList';
import { ListItemIcon, ListItemText } from '@mui/material';
import { ReactNode } from 'react';

export const ContextMenuAction = ({
  icon,
  label,
  onClick,
}: {
  icon: ReactNode;
  label: ReactNode;
  onClick: () => void;
}) => (
  <StyledListItem onClick={onClick}>
    <ListItemIcon>{icon}</ListItemIcon>
    <ListItemText>{label}</ListItemText>
  </StyledListItem>
);
